var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTagSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 14a2 2 0 1 1 .002-4.002A2 2 0 0 1 18 14m4-7h-6.914c-.276 0-.658.158-.854.354l-6.939 6.939a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414 0l6.939-6.94c.196-.195.354-.577.354-.853V8a1 1 0 0 0-1-1"
})));
export default SvgTagSolid;